import styled from 'styled-components';

const Container = styled.div``;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 500px) {
    flex-direction: column;

    h1 {
      margin-bottom: 2rem;
    }
  }
`;

const ProjectsList = styled.div`
  margin-top: 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem 2rem;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

const SelectLabel = styled.p`
  font-size: 1.25rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ink-faint);
`;

const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 20rem;
`;

export { Container, Header, ProjectsList, FilterGroup, SelectLabel };
